export default __webpack_public_path__ + "static/media/E-endure.5cdd3a9e.png";